import React from 'react'

interface State {
  error: Error | null
  info: string
}

/**
 * Catches render errors and shows the message + stack on screen.
 * Without this, any thrown error unmounts the tree and leaves a black screen
 * with no clue in Telegram's WebView (where DevTools is awkward to reach).
 */
export default class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  state: State = { error: null, info: '' }

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ info: info.componentStack ?? '' })
    // Keep it in the console too for DevTools / sourcemap resolution
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          padding: 20, color: '#F5F4F0', background: '#0A0A0B',
          minHeight: '100vh', fontFamily: 'monospace', fontSize: 12,
          whiteSpace: 'pre-wrap', wordBreak: 'break-word',
        }}>
          <div style={{ color: '#ff6b6b', fontSize: 14, marginBottom: 10 }}>
            ⚠️ {this.state.error.name}: {this.state.error.message}
          </div>
          <div style={{ color: '#A8A8AE' }}>{this.state.error.stack}</div>
          <div style={{ color: '#8A8A96', marginTop: 12 }}>{this.state.info}</div>
        </div>
      )
    }
    return this.props.children
  }
}
